/* SQ Sidebar v2 (Sep 28 2026). Layered ON TOP of the existing rail scripts, which still decide which categories
   appear. This file only: labels the Browse box, adds item counts, builds the Filter box (Price, Color / Pattern,
   Manufacturer, plus any filters Shopify's Search & Discovery app provides), adds filter chips + breadcrumb, and
   the phone bar. Counts come from the ?view=sqcount template (templates/collection.sqcount.liquid).
   Color / Pattern and Manufacturer use product tags ("SQ Color/Pattern: X", "SQ Manufacturer: X") through the
   collection tag URL, so one color and one manufacturer can be combined: /collections/h/<color-tag>+<mfr-tag>. */
(function () {
  if (window.__sqv2) return; window.__sqv2 = true;
  var rail = document.querySelector('[data-sq-collection-rail]');
  if (!rail) return;
  var html = document.documentElement;
  html.classList.add('sqv2');

  var here = new URL(location.href);
  var PREVIEW = here.searchParams.get('preview_theme_id');
  var pathParts = here.pathname.split('/').filter(Boolean); // ['collections', handle, (tags)]
  var handle = decodeURIComponent(pathParts[1] || '');
  var basePath = '/collections/' + pathParts[1];
  var activeTags = pathParts[2] ? decodeURIComponent(pathParts[2]).split('+') : [];
  var colorTag = activeTags.filter(function (t) { return t.indexOf('sq-color-pattern-') === 0; })[0] || '';
  var mfrTag = activeTags.filter(function (t) { return t.indexOf('sq-manufacturer-') === 0; })[0] || '';
  var h1 = document.querySelector('#MainContent h1');
  var curTitle = (rail.getAttribute('data-collection-title') || (h1 && h1.textContent) || '').trim();

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function tagPath(c, m) { var p = [c, m].filter(Boolean).map(encodeURIComponent); return basePath + (p.length ? '/' + p.join('+') : ''); }
  function withPath(p) { var u = new URL(location.href); u.pathname = p; u.searchParams.delete('page'); return u.pathname + u.search; }

  /* ---------- counts (cached 10 min per session) ---------- */
  var cache = {}; try { cache = JSON.parse(sessionStorage.getItem('sqv2c') || '{}'); } catch (e) {}
  function saveCache() { try { sessionStorage.setItem('sqv2c', JSON.stringify(cache)); } catch (e) {} }
  function countKey(href) {
    var u = new URL(href, location.origin);
    ['page', 'sq_root', 'sort_by', 'view', 'preview_theme_id', '_pos', '_fid', '_ss'].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.sort(); return u.pathname + '?' + u.searchParams.toString();
  }
  var queue = [], running = 0, inflight = {};
  function getInfo(href) {
    var key = countKey(href), hit = cache[key];
    if (hit && Date.now() - hit.at < 600000) return Promise.resolve(hit);
    if (inflight[key]) return inflight[key];
    inflight[key] = new Promise(function (resolve) { queue.push({ key: key, resolve: resolve }); pump(); });
    return inflight[key];
  }
  function pump() {
    while (running < 4 && queue.length) {
      (function (job) {
        running++;
        var u = new URL(job.key, location.origin); u.searchParams.set('view', 'sqcount'); if (PREVIEW) u.searchParams.set('preview_theme_id', PREVIEW);
        fetch(u.pathname + u.search, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          var v = d && typeof d.c === 'number' ? { c: d.c, t: d.t || '', at: Date.now() } : null;
          if (v) { cache[job.key] = v; saveCache(); }
          job.resolve(v);
        }).catch(function () { job.resolve(null); }).then(function () { running--; pump(); });
      })(queue.shift());
    }
  }
  function putCount(target, href, opt) {
    if (!target || target.querySelector('.sqv2-count')) return;
    var badge = el('span', 'sqv2-count', ''); target.appendChild(badge);
    getInfo(href).then(function (v) { if (!v) { badge.remove(); return; } badge.textContent = v.c > 25000 ? '25,000+' : v.c.toLocaleString(); if (opt && v.c === 0) opt.classList.add('is-empty'); });
  }

  /* ---------- URL helpers ---------- */
  function go(u) { u.searchParams.delete('page'); location.href = u.pathname + u.search; }
  function currentUrl() { return new URL(location.href); }

  /* ---------- Browse box ---------- */
  var nav = rail.querySelector('.sq-collection-rail__nav');
  if (nav && !nav.querySelector('.sqv2-box__head')) nav.insertBefore(el('h2', 'sqv2-box__head', 'Browse'), nav.firstChild);

  function enhanceBrowse() {
    rail.querySelectorAll('.sq-collection-rail__nav .sq-collection-rail__trigger, .sq-collection-rail__nav .sq-collection-rail__primary > li').forEach(function (b) { b.style.setProperty('background', 'transparent', 'important'); b.style.setProperty('box-shadow', 'none', 'important'); });
    var direct = rail.querySelector('.sq-collection-rail__direct');
    if (direct && direct.dataset.sqv2 !== direct.getAttribute('href')) {
      direct.dataset.sqv2 = direct.getAttribute('href');
      direct.querySelectorAll('.sqv2-back, .sqv2-count').forEach(function (x) { x.remove(); });
      var rootHandle = ''; try { rootHandle = decodeURIComponent(new URL(direct.href).pathname.split('/')[2] || ''); } catch (e) {}
      var span = direct.querySelector('span');
      if (rootHandle && rootHandle !== handle) {
        direct.insertBefore(el('span', 'sqv2-back', '‹'), direct.firstChild);
        getInfo(direct.href).then(function (v) { if (v && v.t && span) { span.textContent = 'All ' + v.t; addCrumbRoot(direct.href, v.t); } });
      } else if (span) {
        span.textContent = 'All ' + curTitle;
        putCount(direct, direct.href);
      }
    }
    rail.querySelectorAll('.sq-collection-rail__links a[href]').forEach(function (a) {
      if (a.closest('[data-sqv2-moved]')) return;
      var u; try { u = new URL(a.href); } catch (e) { return; }
      if (u.pathname.replace(/\/$/, '') === here.pathname.replace(/\/$/, '') && !a.dataset.sqv2cur) {
        a.dataset.sqv2cur = '1';
        if (!rail.querySelector('a.sqv2-current')) { a.classList.add('sqv2-current'); a.setAttribute('aria-current', 'page'); }
      }
      if (!/\/collections\//.test(u.pathname) || u.searchParams.has('filter.v.price.gte') || u.searchParams.has('filter.v.price.lte') || u.searchParams.has('filter.p.vendor')) return;
      putCount(a, a.href);
    });
  }

  /* ---------- Filter box ---------- */
  var chipsData = [], chipsEl = null;
  var box = rail.querySelector('[data-sqv2-filter]');
  if (!box) { box = el('div', 'sqv2-filter'); box.setAttribute('data-sqv2-filter', ''); box.appendChild(el('h2', 'sqv2-box__head', 'Filter')); (rail.querySelector('[data-sq-rail-body]') || rail).appendChild(box); }
  var tpl = document.querySelector('template[data-sqv2-native-tpl]');
  if (tpl && !box.querySelector('[data-sqv2-native]')) box.appendChild(tpl.content.cloneNode(true));
  var nativeLists = box.querySelectorAll('[data-sqv2-native]');

  function section(title, open) {
    var d = el('details', 'sqv2-sec'); if (open) d.open = true;
    d.appendChild(el('summary', '', title)); var ul = el('ul'); d.appendChild(ul); return { d: d, ul: ul };
  }
  function optionLink(label, href, active, kind, dot) {
    var li = el('li'), a = el('a', 'sqv2-opt'); a.href = href;
    var inp = el('input'); inp.type = kind; inp.checked = !!active; inp.tabIndex = -1; inp.setAttribute('aria-hidden', 'true');
    a.appendChild(inp); if (dot) { var s = el('span', 'sqv2-dot'); s.style.background = dot; a.appendChild(s); }
    a.appendChild(el('span', 'sqv2-lbl', label)); li.appendChild(a); return { li: li, a: a };
  }

  // Sort (phone sheet only; desktop keeps the theme's Sort dropdown)
  (function () {
    var src = document.querySelector('select[name="sort_by"]'); if (!src || box.querySelector('.sqv2-sort')) return;
    var wrap = el('div', 'sqv2-sort'), s = section('Sort', true); s.d.removeChild(s.ul);
    var sel = el('select'); sel.setAttribute('aria-label', 'Sort');
    Array.prototype.forEach.call(src.options, function (o) { var n = el('option', '', norm(o.textContent)); n.value = o.value; if (o.selected) n.selected = true; sel.appendChild(n); });
    sel.addEventListener('change', function () { var u = currentUrl(); u.searchParams.set('sort_by', sel.value); go(u); });
    s.d.appendChild(sel); wrap.appendChild(s.d); box.insertBefore(wrap, box.querySelector('.sqv2-box__head').nextSibling);
  })();

  // Price presets (Shopify's native price filter)
  var RANGES = [[0, 25], [25, 50], [50, 100], [100, 250], [250, 500], [500, null]];
  var gte = here.searchParams.get('filter.v.price.gte'), lte = here.searchParams.get('filter.v.price.lte');
  function priceLabel(r) { return r[1] == null ? '$' + r[0] + ' & up' : '$' + r[0] + ' – $' + r[1]; }
  function priceUrl(r) { var u = currentUrl(); u.searchParams.delete('page'); u.searchParams.delete('filter.v.price.gte'); u.searchParams.delete('filter.v.price.lte'); if (r) { if (r[0]) u.searchParams.set('filter.v.price.gte', r[0]); if (r[1] != null) u.searchParams.set('filter.v.price.lte', r[1]); } return u; }
  function isActivePrice(r) { return (String(r[0] || '') === String(gte ? Number(gte) : '') || (!r[0] && !gte)) && (r[1] == null ? !lte : String(r[1]) === String(lte ? Number(lte) : '')) && (gte || lte); }
  var priceSec = section('Price', true), priceProms = [];
  RANGES.forEach(function (r) {
    var active = isActivePrice(r), u = priceUrl(active ? null : r);
    var o = optionLink(priceLabel(r), u.pathname + u.search, active, 'radio');
    priceSec.ul.appendChild(o.li); putCount(o.a, priceUrl(r).href, o.a); priceProms.push(getInfo(priceUrl(r).href));
  });
  // Shopify ignores filters on collections over 25,000 products: every range then returns the same total. Hide Price there.
  Promise.all(priceProms).then(function (vs) {
    var c = vs.map(function (v) { return v ? v.c : -1; });
    if (c[0] > 25000 || (c[0] > 0 && c.every(function (x) { return x === c[0]; }))) priceSec.d.remove();
  });
  box.insertBefore(priceSec.d, nativeLists[0] || null);

  // Color / Pattern: reuse the existing rail's tag links (one color at a time; combines with a manufacturer)
  var COLORS = { black: '#111', blue: '#2458a6', 'brown / tan': '#a47b4f', camouflage: 'linear-gradient(135deg,#5b6b3a 0 30%,#8a7a52 30% 55%,#3c3a28 55% 75%,#6f7b4c 75%)', coyote: '#8b6b45', 'coyote / tan 499': '#8b6b45', 'olive drab': '#5a5f32', gray: '#8a8f94', grey: '#8a8f94', green: '#3f6b3a', 'olive / od green': '#5a5f32', 'ranger green': '#4b523a', multicam: 'linear-gradient(135deg,#7c6e4d 0 30%,#a39468 30% 55%,#4c4a33 55% 75%,#8b8a5c 75%)', red: '#b31942', white: '#fff', orange: '#e4782a', yellow: '#e6c229', purple: '#6a3d9a', pink: '#e27aa9', silver: '#c0c4c8', gold: '#d5ab4b', 'multi-color': 'conic-gradient(#b31942,#e6c229,#3f6b3a,#2458a6,#b31942)', 'other / assorted': '#d7dbde' };
  var colorBuilt = false, colorSec = null;
  function buildColor(item) {
    if (colorBuilt) return; colorBuilt = true;
    var links = item.querySelectorAll('ul a[href]'); if (!links.length) return;
    var sec = section('Color / Pattern', !!colorTag); colorSec = sec.d; var seen = {};
    Array.prototype.forEach.call(links, function (a) {
      var t; try { t = new URL(a.href); } catch (e) { return; }
      var seg = decodeURIComponent(t.pathname.split('/')[3] || '');
      var cs = seg.split(/[+ ]/).filter(function (x) { return x.indexOf('sq-color-pattern-') === 0; });
      var tag = cs.length > 1 ? (cs.filter(function (x) { return x !== colorTag; })[0] || cs[0]) : (cs[0] || ''); if (!tag) return;
      if (seen[tag]) return; seen[tag] = 1;
      var active = tag === colorTag;
      var label = norm(a.textContent), o = optionLink(label, withPath(tagPath(active ? '' : tag, mfrTag)), active, 'radio', COLORS[label.toLowerCase()] || null);
      if (active) { chipsData.unshift({ label: label, href: withPath(tagPath('', mfrTag)) }); renderChips(); }
      sec.ul.appendChild(o.li); putCount(o.a, withPath(tagPath(tag, mfrTag)), o.a);
    });
    if (colorTag && !seen[colorTag]) {
      var ct = document.querySelector('template[data-sqv2-color-tpl]'), lab = '';
      if (ct) { var hit = ct.content.querySelector('li[data-tag="' + colorTag + '"]'); if (hit) lab = hit.getAttribute('data-label'); }
      if (!lab) lab = colorTag.replace('sq-color-pattern-', '').split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
      var oa = optionLink(lab, withPath(tagPath('', mfrTag)), true, 'radio', COLORS[lab.toLowerCase()] || null);
      sec.ul.insertBefore(oa.li, sec.ul.firstChild); putCount(oa.a, withPath(tagPath(colorTag, mfrTag)), oa.a);
      chipsData.unshift({ label: lab, href: withPath(tagPath('', mfrTag)) }); renderChips();
    }
    box.insertBefore(sec.d, mfrSec || nativeLists[0] || null);
  }

  // Manufacturer: from "SQ Manufacturer: X" tags in this collection (template rendered by sq-sidebar-v2-filter.liquid)
  var mfrSec = null;
  (function () {
    var mt = document.querySelector('template[data-sqv2-mfr-tpl]'); if (!mt) return;
    var items = Array.prototype.slice.call(mt.content.querySelectorAll('li[data-tag]'));
    if (!items.length) return;
    var sec = section('Manufacturer', !!mfrTag); mfrSec = sec.d;
    if (items.length > 10) {
      var find = el('input', 'sqv2-find'); find.type = 'search'; find.placeholder = 'Find a manufacturer…'; find.setAttribute('aria-label', 'Find a manufacturer');
      find.addEventListener('input', function () { var q = find.value.trim().toLowerCase(); sec.ul.querySelectorAll('li').forEach(function (li) { li.hidden = q && li.textContent.toLowerCase().indexOf(q) === -1; }); });
      sec.d.insertBefore(find, sec.ul);
    }
    var opts = [];
    items.forEach(function (it) {
      var tag = it.getAttribute('data-tag'), label = it.getAttribute('data-label'), active = tag === mfrTag;
      var o = optionLink(label, withPath(tagPath(colorTag, active ? '' : tag)), active, 'radio');
      if (active) { chipsData.push({ label: label, href: withPath(tagPath(colorTag, '')) }); }
      sec.ul.appendChild(o.li); opts.push([o.a, withPath(tagPath(colorTag, tag))]);
    });
    // counts only once the section is opened (some pages have 60+ manufacturers)
    function loadCounts() { if (sec.d.dataset.counted) return; sec.d.dataset.counted = '1'; opts.forEach(function (x) { putCount(x[0], x[1], x[0]); }); }
    if (sec.d.open) loadCounts(); sec.d.addEventListener('toggle', function () { if (sec.d.open) loadCounts(); });
    box.insertBefore(sec.d, nativeLists[0] || null);
    if (colorSec) box.insertBefore(colorSec, sec.d);
  })();

  // Native list filters rendered by Liquid (appear automatically once enabled in Search & Discovery)
  box.addEventListener('change', function (e) {
    var inp = e.target; if (!inp || !inp.matches('[data-sqv2-native] input[type=checkbox]')) return;
    var u = currentUrl(); u.searchParams.delete(inp.name);
    box.querySelectorAll('input[type=checkbox][name="' + inp.name + '"]:checked').forEach(function (c) { u.searchParams.append(inp.name, c.value); });
    go(u);
  });

  // Legacy rail items: Price + Manufacturer are replaced; Color / Pattern moves into the Filter box
  function sweepLegacy() {
    rail.querySelectorAll('.sq-collection-rail__primary > li').forEach(function (li) {
      if (li.dataset.sqv2moved) return;
      var label = norm((li.querySelector('.sq-collection-rail__trigger span') || {}).textContent).toLowerCase();
      if (label === 'price' || label === 'manufacturer' || label === 'brand') { li.setAttribute('data-sqv2-moved', ''); li.dataset.sqv2moved = '1'; }
      else if (label === 'color / pattern' || label === 'color' || label === 'colour') { buildColor(li); li.setAttribute('data-sqv2-moved', ''); li.dataset.sqv2moved = '1'; }
    });
  }

  /* ---------- chips ---------- */
  function renderChips() {
    if (!chipsEl) {
      chipsEl = el('div', 'sqv2-chips'); chipsEl.setAttribute('aria-label', 'Active filters');
      var anchor = document.querySelector('.facets-block-wrapper--horizontal') || document.querySelector('collection-component');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(chipsEl, anchor); else return;
    }
    chipsEl.innerHTML = ''; chipsEl.hidden = !chipsData.length; if (!chipsData.length) return;
    chipsData.forEach(function (c) { var a = el('a', 'sqv2-chip'); a.href = c.href; a.setAttribute('aria-label', 'Remove ' + c.label); a.appendChild(el('span', '', c.label)); a.appendChild(el('b', '', '×')); chipsEl.appendChild(a); });
    var clr = el('a', 'sqv2-clear', 'Clear all'), u = currentUrl(); u.pathname = basePath;
    Array.from(u.searchParams.keys()).forEach(function (k) { if (/^filter\./.test(k) && k !== 'filter.v.availability') u.searchParams.delete(k); });
    u.searchParams.delete('page'); clr.href = u.pathname + u.search; chipsEl.appendChild(clr);
  }
  if (gte || lte) { var pl = gte && lte ? '$' + Number(gte) + ' – $' + Number(lte) : gte ? '$' + Number(gte) + ' & up' : 'Up to $' + Number(lte); var pu = priceUrl(null); chipsData.push({ label: pl, href: pu.pathname + pu.search }); }
  box.querySelectorAll('[data-sqv2-native] input:checked').forEach(function (c) { var u = currentUrl(); var vals = u.searchParams.getAll(c.name).filter(function (v) { return v !== c.value; }); u.searchParams.delete(c.name); vals.forEach(function (v) { u.searchParams.append(c.name, v); }); u.searchParams.delete('page'); chipsData.push({ label: norm(c.getAttribute('data-label') || c.value), href: u.pathname + u.search }); });
  renderChips();

  /* ---------- breadcrumb ---------- */
  var crumbs = null;
  function buildCrumbs() {
    if (!h1 || crumbs) return;
    crumbs = el('nav', 'sqv2-crumbs'); crumbs.setAttribute('aria-label', 'Breadcrumb');
    var home = el('a', '', 'Home'); home.href = '/'; crumbs.appendChild(home);
    crumbs.appendChild(el('span', '', '›')); var cur = el('span', '', curTitle); cur.setAttribute('aria-current', 'page'); crumbs.appendChild(cur);
    var host = h1.closest('.text-block') || h1; host.parentNode.insertBefore(crumbs, host);
  }
  function addCrumbRoot(href, title) {
    buildCrumbs(); if (!crumbs || crumbs.dataset.root) return; crumbs.dataset.root = '1';
    var a = el('a', '', title); a.href = href; var sep = el('span', '', '›');
    crumbs.insertBefore(sep, crumbs.children[2]); crumbs.insertBefore(a, sep);
  }
  buildCrumbs();

  /* ---------- phone bar + sheets ---------- */
  var mq = window.matchMedia('(max-width: 749px)');
  var scrim = el('div', 'sqv2-scrim'); scrim.hidden = true; document.body.appendChild(scrim);
  function makeSheet(title, node) {
    var sh = el('div', 'sqv2-sheet'); sh.hidden = true; sh.setAttribute('role', 'dialog'); sh.setAttribute('aria-label', title);
    var head = el('div', 'sqv2-sheet__head'); head.appendChild(el('span', '', title)); var x = el('button', '', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Close'); head.appendChild(x);
    var body = el('div', 'sqv2-sheet__body'); sh.appendChild(head); sh.appendChild(body); document.body.appendChild(sh);
    x.addEventListener('click', closeSheets); return { sh: sh, body: body, node: node, home: node.parentNode, next: node.nextSibling };
  }
  var browseSheet = nav ? makeSheet('Browse', nav) : null, filterSheet = makeSheet('Filter & Sort', box);
  (function () {
    var foot = el('div', 'sqv2-sheet__foot'), clr = el('a', '', 'Clear all'), show = el('button', '', 'Show items');
    var u = currentUrl(); u.pathname = basePath; Array.from(u.searchParams.keys()).forEach(function (k) { if (/^filter\./.test(k) && k !== 'filter.v.availability') u.searchParams.delete(k); }); clr.href = u.pathname + u.search;
    var countTxt = norm((document.querySelector('.products-count-wrapper [role=status]') || {}).textContent); if (countTxt) show.textContent = 'Show ' + countTxt;
    show.type = 'button'; show.addEventListener('click', closeSheets); foot.appendChild(clr); foot.appendChild(show); filterSheet.sh.appendChild(foot);
  })();
  function openSheet(s) { if (!s) return; closeSheets(); s.body.appendChild(s.node); s.sh.hidden = false; scrim.hidden = false; html.classList.add('sqv2-sheet-open'); }
  function closeSheets() {
    [browseSheet, filterSheet].forEach(function (s) { if (!s || s.sh.hidden) return; s.sh.hidden = true; if (s.next && s.next.parentNode === s.home) s.home.insertBefore(s.node, s.next); else s.home.appendChild(s.node); });
    scrim.hidden = true; html.classList.remove('sqv2-sheet-open');
  }
  scrim.addEventListener('click', closeSheets);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });
  mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches) closeSheets(); });
  var bar = el('div', 'sqv2-mbar'), bB = el('button', '', 'Browse'), bF = el('button', '', 'Filter & Sort');
  bB.type = bF.type = 'button'; if (chipsData.length) bF.textContent = 'Filter & Sort (' + chipsData.length + ')';
  bB.addEventListener('click', function () { openSheet(browseSheet); }); bF.addEventListener('click', function () { openSheet(filterSheet); });
  bar.appendChild(bB); bar.appendChild(bF); rail.insertBefore(bar, rail.firstChild);

  /* ---------- run + re-run while the older rail scripts finish building ---------- */
  function run() { sweepLegacy(); enhanceBrowse(); }
  run();
  var t = null, mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 120); });
  mo.observe(rail, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  window.addEventListener('sq:sidebar-tree-data-ready', function () { setTimeout(run, 0); });
  setTimeout(function () { mo.disconnect(); run(); }, 12000);
})();